import { createApi } from "@reduxjs/toolkit/query/react";
import { baseProxyQueryWithReauth } from "./API";

export const monitoringProxyAPI = createApi({
  reducerPath: "monitoringProxyAPI",
  baseQuery: baseProxyQueryWithReauth("logic/workflows/api"),
  refetchOnMountOrArgChange: true,
  tagTypes: ["Monitors"],

  endpoints: (builder) => ({
    getMonitors: builder.query<
      { monitors: any[]; total: number },
      { offset?: number; limit?: number }
    >({
      query: (params) => ({
        url: `/monitor/rules`,
        params,
      }),
      providesTags: ["Monitors"],
    }),
    getMonitor: builder.query<any, { uuid: string }>({
      query: ({ uuid }) => ({
        url: `/monitor/rules/${uuid}`,
      }),
      providesTags: ["Monitors"],
    }),
    runMonitor: builder.query<any, string>({
      query: (uuid) => `/monitor/run/${uuid}`,
    }),
    updateMonitor: builder.mutation<any, any>({
      query: (body) => {
        return {
          url: `/monitor/rules`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["Monitors"],
    }),
    deleteMonitor: builder.mutation<any, { uuid: string }>({
      query: ({ uuid }) => ({
        url: `/monitor/rules/${uuid}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Monitors"],
    }),
  }),
});
export const {
  useGetMonitorsQuery,
  useUpdateMonitorMutation,
  useDeleteMonitorMutation,
  useGetMonitorQuery,
  useLazyGetMonitorQuery,
  useLazyRunMonitorQuery,
} = monitoringProxyAPI;
